import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DevicesTable } from '../components/devices/DevicesTable';
import { CreateDeviceModal } from '../components/devices/CreateDeviceModal';
import { DeviceCreate } from '../api/models/DeviceCreate';
import { useClientAccess } from '../hooks/useClientAccess';

export const DevicesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshDevices, setRefreshDevices] = useState(0);
  const { canManageDevices } = useClientAccess();

  // Get device type filter from URL params (e.g., /devices?type=ABEEWAY)
  const typeFilter = searchParams.get('type') || undefined;

  const handleDeviceCreated = (_device: DeviceCreate) => {
    // Trigger refresh of devices table
    setRefreshDevices(prev => prev + 1);
  };

  return (
    <div className="page">
      <div className="page-content">
        <div className="page-header">
          <div className="page-title">
            <h1>📱 Device Management</h1>
            <p>Device Management & Monitoring</p>
          </div>
          <div className="page-actions">
            {canManageDevices && (
              <button
                className="create-device-btn"
                data-testid="btn-add-device"
                onClick={() => setShowCreateModal(true)}
              >
                <span className="add-type-icon" aria-hidden="true">+</span>
                Add Device
              </button>
            )}
          </div>
        </div>

        <DevicesTable
          onDeviceSelect={() => {}}
          refreshTrigger={refreshDevices}
          initialDeviceTypeFilter={typeFilter}
        />

        <CreateDeviceModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onDeviceCreated={handleDeviceCreated}
        />
      </div>
    </div>
  );
};
